import { useRef, useState } from 'react'
import { useLocation } from 'react-router-dom'

import AuthorizeUser from 'modules/core/components/AuthorizeUser'
import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useEffect } from 'modules/core/hooks/useEffect'
import { track, trackingEvents } from 'modules/core/lib/Tracking'

import FactorialBundles from 'modules/billing/components/FactorialBundles'
import FactorialF25Bundles from 'modules/billing/components/FactorialF25Bundles'
import PersonalisedHub from 'modules/billing/components/PersonalisedHub'
import { BundleConfig } from 'modules/billing/pages/BundlesHomepage/types'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import DatoPlansProvider, {
  useDatoPlans,
} from 'modules/onboarding/components/Pricing/DatoPlansContext'
import { F25PricingProvider } from 'modules/onboarding/components/Pricing/F25PricingContext'

const PricingPlans = () => {
  const { pathname } = useLocation()
  const { datoPlans } = useDatoPlans()
  const [configPlan, setConfigPlan] = useState<BundleConfig>({
    period: 'monthly',
    bundle: 'Operations Hub',
  })
  const hubsSectionRef = useRef<HTMLElement>(null)

  useEffect(() => {
    track(trackingEvents.billing.viewPricingPlans)
    const utmSource = new URLSearchParams(window.location.search).get('utm_source')
    if (!!utmSource) {
      track(trackingEvents.billing.goToPricingPlans, {
        page_path: pathname,
        from: utmSource,
      })
    }
  }, [pathname])

  if (!datoPlans) return null

  return (
    <ResponsivePage.Body variant="full" loading={!datoPlans} error={null}>
      <PersonalisedHub hubsSectionRef={hubsSectionRef} />
      <FactorialBundles
        bundlesStructure={datoPlans.pricingBundlePlanStructure}
        configPlan={configPlan}
        setConfigPlan={setConfigPlan}
        hubsSectionRef={hubsSectionRef}
      />
    </ResponsivePage.Body>
  )
}

const F25PricingPlans = () => {
  const { datoPlans } = useDatoPlans()

  useEffect(() => {
    track(trackingEvents.billing.viewPricingPlans)
  }, [])

  if (!datoPlans) return null

  return (
    <ResponsivePage.Body variant="full" loading={!datoPlans} error={null}>
      <FactorialF25Bundles />
    </ResponsivePage.Body>
  )
}

const BundlesHomePage = () => {
  const {
    company: { subscription },
  } = useCurrentSession()

  return (
    <AuthorizeUser authorizeFn={() => subscription.inFreeTrial}>
      <DatoPlansProvider>
        <F25PricingProvider>
          <F25PricingPlans />
        </F25PricingProvider>
      </DatoPlansProvider>
    </AuthorizeUser>
  )
}

export default BundlesHomePage
